import { useEffect, useState } from 'react'
import { Ga4Events } from '../../events/index'
import { useCart } from '../../../../core/hooks/index'

export const ViewCart = () => {
  const { cart } = useCart()

  const [firstLoaded, setFirstLoaded] = useState(true)

  useEffect(() => {
    if (firstLoaded && Boolean(cart?.data?.items?.length)) {
      setFirstLoaded(false)
      Ga4Events.viewCart({ cart })
    }
  }, [firstLoaded, cart])

  return null
}
